/*
Copyright (c) 2018 Ady Levy
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { withStyles } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";
import ActionDelete from "@material-ui/icons/Delete";
import classnames from "classnames";
import { crudDeleteMany, startUndoable, translate } from "ra-core";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { Button } from "react-admin";
import SettingsIcon from "@material-ui/icons/Settings";
import DownloadIcon from "@material-ui/icons/GetApp";
import { competitionPaid, getCompetitionsByIds } from "../utils/restUtils";
import { unparse } from "papaparse";
import moment from "moment";
import CheckIcon from "@material-ui/icons/Check";
import { push } from "react-router-redux";

const styles = theme => ({
  deleteButton: {
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: fade(theme.palette.error.main, 0.12),
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  }
});

class PopupBulkEventButton extends Component {
  state = {
    showDialog: false
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handlePaid = event => {
    event.preventDefault();

    const { selectedIds } = this.props;

    competitionPaid(selectedIds).then(() => {
      this.setState({ showDialog: false });
      this.props.dispatch(push("/events_"));
      this.props.dispatch(push("/events"));
    });
  };

  handleDelete = event => {
    event.preventDefault();
    this.setState({ showDialog: false });
    const {
      dispatchCrudDeleteMany,
      startUndoable,
      resource,
      selectedIds,
      basePath,
      redirect,
      undoable
    } = this.props;
    if (undoable) {
      startUndoable(crudDeleteMany(resource, selectedIds, basePath, redirect));
    } else {
      dispatchCrudDeleteMany(resource, selectedIds, basePath, redirect);
    }
  };

  render() {
    const { showDialog } = this.state;
    const {
      label = "resources.competitions.listPage.actions",
      classes = {},
      className,
      selectedIds,
      titleSource
    } = this.props;
    return (
      <Fragment>
        <Button
          onClick={this.handleClick}
          label={label}
          className={classnames(className)}
          key="button"
        >
          <SettingsIcon />
        </Button>
        <Dialog
          fullWidth
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Are you sure?"
        >
          <DialogContent>
            <div>{this.props.translate(this.props.message)}</div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleDelete}
              label="ra.action.delete"
              className={classnames(
                "ra-delete-button",
                classes.deleteButton,
                className
              )}
              key="button"
            >
              <ActionDelete />
            </Button>
            <Button onClick={this.handlePaid} label="orderList.payButton">
              <CheckIcon />
            </Button>
            <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

PopupBulkEventButton.propTypes = {
  basePath: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  dispatchCrudDeleteMany: PropTypes.func.isRequired,
  label: PropTypes.string,
  selectedIds: PropTypes.array,
  redirect: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.func
  ]),
  resource: PropTypes.string.isRequired,
  startUndoable: PropTypes.func,
  translate: PropTypes.func,
  message: PropTypes.string,
  undoable: PropTypes.bool
};

PopupBulkEventButton.defaultProps = {
  redirect: "list",
  undoable: true,
  message: "bulkCompetitionPopup.title"
};

const mapDispatchToProps = dispatch => ({
  push,
  dispatch,
  startUndoable,
  dispatchCrudDeleteMany: crudDeleteMany
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
  translate,
  withStyles(styles)
)(PopupBulkEventButton);
